import AdminPublicLayout from "@/layouts/AdminPublicLayout";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";

const Guides = () => {
    const { t } = useTranslation();
    const [guides, setGuides] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = `${t('guides.title')} - FitCalendar`;

        const loadGuides = async () => {
            try {
                const res = await fetch("/guides/index.json");
                const data = await res.json();
                setGuides(data);
            } catch (error) {
                console.error("❌ Failed to load guides index:", error);
            } finally {
                setLoading(false);
            }
        };

        loadGuides();
    }, [t]);

    return (
        <AdminPublicLayout>
            <Helmet>
                <title>{t("guides.title")} | FitCalendar</title>
                <link rel="canonical" href="https://fitcalendar.praxipro.io/guides/" />
            </Helmet>

            <main className="flex-1 py-16 px-4">
                <section className="text-center max-w-5xl mx-auto">
                    <h1 className="text-4xl font-bold mb-8">{t('guides.title') || 'Guides'}</h1>

                    {loading ? (
                        <p>{t('guides.loading') || 'Loading guides...'}</p>
                    ) : guides.length === 0 ? (
                        <p>{t('guides.empty') || 'No guides found.'}</p>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-left">
                            {guides.map(({ title, description, filename }) => {
                                const slug = filename.replace(/\.[^/.]+$/, "");
                                return (
                                    <a
                                        key={filename}
                                        href={`/guides/${slug}`}
                                        className="block p-4 border rounded-md hover:shadow-lg transition bg-white"
                                    >
                                        <h2 className="text-xl font-semibold text-primary mb-2">{title}</h2>
                                        <p className="text-gray-600 text-sm">{description}</p>
                                    </a>
                                );
                            })}
                        </div>
                    )}
                </section>
            </main>
        </AdminPublicLayout>
    );
};

export default Guides;